import { CircularProgress } from '@material-ui/core';
import React from 'react';

const Loader: React.FC = () => {
    return (
        <div id="loader" style={{ display: 'none', visibility: 'hidden' }}>
            <CircularProgress color="primary" thickness={2} size={50} />
        </div>
    );
};

export default Loader;
